import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import type { FC } from "react";

import { AppSearch } from "~/feature/search/components/AppSearch";

import * as Styled from "./SearchAutocompleteDialog.styles";

interface ISearchAutocompleteDialogProps {
  open: boolean;
  onClose: () => void;
}

export const SearchAutocompleteDialog: FC<ISearchAutocompleteDialogProps> = ({
  open,
  onClose,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Styled.RootDialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth="sm"
    >
      <Styled.Content>
        <Styled.SearchWrapper>
          <AppSearch onDone={onClose} autoFocus />
        </Styled.SearchWrapper>
      </Styled.Content>
    </Styled.RootDialog>
  );
};
